import { useState } from "react";

export default function Login({ onSignIn }: { onSignIn: () => void }) {
  const [email, setEmail] = useState("ananya@preethi.example");
  const [busy, setBusy] = useState(false);

  const proceed = () => {
    setBusy(true);
    setTimeout(onSignIn, 420);
  };

  return (
    <div className="login-wrap">
      <div className="brand-panel">
        <div className="hdr">
          <span className="dot" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2 12 H6 L8.5 6 L12 18 L15.5 9 L17.5 13 H22" stroke="currentColor" strokeWidth="2.4" />
            </svg>
          </span>
          <span>Market <strong style={{ color: "#F3D9A8", fontWeight: 600 }}>Pulse</strong></span>
        </div>
        <div className="pull">
          Every survey you have ever funded, <em>finally working for you.</em>
        </div>
        <div className="sig">
          <span>Preethi workspace</span>
          <span>·</span>
          <span>Azure EU-W1</span>
          <span>·</span>
          <span>SSO enforced</span>
        </div>
      </div>

      <div className="form">
        <h2>Welcome back</h2>
        <div className="sub">Use your workspace credentials to continue. Demo visitors can use any details below.</div>

        <div className="sso">
          <button onClick={proceed}>
            <svg width="16" height="16" viewBox="0 0 24 24"><path fill="#EA4335" d="M12 5a7 7 0 0 1 5 2l3-3A11 11 0 1 0 12 23a10 10 0 0 0 10-10v-1h-10v3h6a5 5 0 0 1-10-1 7 7 0 0 1 4-6z"/></svg>
            Continue with Google
          </button>
          <button onClick={proceed}>
            <svg width="16" height="16" viewBox="0 0 24 24"><rect x="3" y="3" width="8" height="8" fill="#F25022"/><rect x="13" y="3" width="8" height="8" fill="#7FBA00"/><rect x="3" y="13" width="8" height="8" fill="#00A4EF"/><rect x="13" y="13" width="8" height="8" fill="#FFB900"/></svg>
            Microsoft SSO
          </button>
        </div>

        <div className="or">or</div>

        <form onSubmit={(e) => { e.preventDefault(); proceed(); }}>
          <label>Work email</label>
          <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
          <label style={{ marginTop: 6 }}>Password</label>
          <input type="password" defaultValue="••••••••••" />
          <button className="btn-primary" type="submit" style={{ width: "100%", marginTop: 10, justifyContent: "center", padding: "10px 14px" }} disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div className="demo-hint">
          <b>Demo mode · </b> Any credentials will let you in. Press <span className="kbd">⌘K</span> anywhere inside the app to jump between screens.
        </div>
      </div>
    </div>
  );
}
